export const CONCEPT_NAMES = {
  collectivity: "Collectivités",
  educapa: "Educapa",
};

export const COMMERCIALS_EMAILS = {
  marketEstablishment: "marche@justcoaching.fr",
};
